// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pv","legalMessage":"pw","navLink":"px","bottomLinkWrapper":"py","bottomLink":"pz px"};